module.exports = __webpack_public_path__ + "static/media/Scouts.2cd0b1f2.png";